<template>
    <div class="cf-container">
        <md-table v-if="hasBlockoutDays" class="blockout-day-table">
            <md-table-row slot="header">
                <md-table-head>Name</md-table-head>
                <md-table-head>Start Date</md-table-head>
                <md-table-head>End Date</md-table-head>
                <md-table-head>Actions</md-table-head>
            </md-table-row>

            <md-table-row v-for="(blockoutDay, index) in filteredBlockoutDays" :key="index">
                <md-table-cell class="blockout-day-name-column">
                    <form-group>
                        <md-input
                            v-model="blockoutDay.blockoutDayName"
                            type="text"
                            placeholder="Eg. Christmas Day"
                            data-testid="blockout-blockoutDayName"
                        />
                    </form-group>
                </md-table-cell>
                <md-table-cell class="date-range-columns">
                    <md-datepicker
                        v-model="blockoutDay.startDate"
                        md-immediately
                        :md-debounce="100"
                        data-testid="blockout-startDate"
                        :md-model-type="String"
                    ></md-datepicker>
                </md-table-cell>
                <md-table-cell class="date-range-columns">
                    <md-datepicker
                        v-model="blockoutDay.endDate"
                        md-immediately
                        :md-debounce="100"
                        data-testid="blockout-endDate"
                        :md-model-type="String"
                    ></md-datepicker>
                </md-table-cell>
                <md-table-cell>
                    <md-button
                        title="Delete blockout day"
                        class="md-danger md-just-icon md-round"
                        @click="deleteBlockoutDay(blockoutDay)"
                    >
                        <md-icon>delete</md-icon>
                    </md-button>
                </md-table-cell>
            </md-table-row>
        </md-table>
        <div class="text-center" v-if="!hasBlockoutDays">
            <p class="no-result-message">List is empty.</p>
        </div>
        <div>
            <md-button class="md-button md-primary custom-add-blockout-day-button" @click="handleAddBlockoutDay">
                <md-icon>add</md-icon>
                Add Blockout Day
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { rowStatus } from '@/helpers';

export default {
    name: 'ServiceAreasBlockoutDay',
    mixins: [GeneralMixin],
    props: {
        serviceAreaId: {
            type: String,
            default: null
        },
        blockoutDayData: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        filteredBlockoutDays() {
            return (this.blockoutDayData?.blockoutDays || []).filter((x) => x.rowStatus !== rowStatus.DELETE);
        },
        hasBlockoutDays() {
            return this.blockoutDayData?.blockoutDays?.length > 0;
        }
    },
    methods: {
        async deleteBlockoutDay(blockoutDay) {
            const index = this.blockoutDayData.blockoutDays.indexOf(blockoutDay);

            if (blockoutDay.rowStatus === rowStatus.ADD && index !== -1) {
                this.blockoutDayData.blockoutDays.splice(index, 1);
                return;
            }

            if (index !== -1) {
                blockoutDay.rowStatus = rowStatus.DELETE;
            }
        },
        handleAddBlockoutDay() {
            const newBlockoutDay = {
                blockoutDayId: null,
                blockoutDayName: null,
                startDate: null,
                endDate: null,
                rowStatus: rowStatus.ADD
            };

            this.blockoutDayData.blockoutDays.push(newBlockoutDay);
        }
    }
};
</script>
<style lang="scss" scoped>
.custom-add-blockout-day-button,
.custom-add-blockout-day-button:hover {
    margin-left: 0;
    background-color: #5f6771 !important;
    margin-top: 10px;
}
.date-range-columns {
    width: 175px;
    min-width: 175px;
    max-width: 175px;
}
.blockout-day-name-column {
    width: 300px;
    min-width: 300px;
    max-width: 300px;
}
.blockout-day-table .md-table-row:nth-child(n + 3) > td {
    border-top: 0 !important;
}
</style>
